const Refreshment = (state) => state.Refreshment
const refreshmentItem = (state) => state.refreshmentItem
const listReceiptPax = (state) => state.listReceiptPax
const InfoBankPax = (state) => state.InfoBankPax
const RefreshmentInfo = (state) => state.refreshmentInfo
const Currencies = (state) => state.Currencies
const Countrys = (state) => state.Countrys
const dataBank = (state) => state.dataBank
const RefreshmentPrice = (state) => state.refreshmentPrice
const dataInfoBankPax = (state) => state.dataInfoBankPax

export default {
  Refreshment,
  refreshmentItem,
  listReceiptPax,
  InfoBankPax,
  RefreshmentInfo,
  Currencies,
  dataBank,
  RefreshmentPrice,
  dataInfoBankPax,
  Countrys
}
